import { render, staticRenderFns } from "./EmojiAvatar.vue?vue&type=template&id=2da9d1c5&"
import script from "./EmojiAvatar.vue?vue&type=script&lang=js&"
export * from "./EmojiAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports